import React from "react";
import { useModalTitleId } from "../ModalShell";

interface WizardStepProps {
  title: string;
  children: React.ReactNode;
}

const ModalStep = ({
  title,
  children,
}: WizardStepProps & {
  children: React.ReactNode;
}): React.JSX.Element => {
  const titleId = useModalTitleId();
  const headingRef = React.useRef<HTMLHeadingElement>(null);

  // Varje steg monteras om, och knappen som klickades försvinner med det förra steget.
  // Fokus flyttas till rubriken så att skärmläsare läser upp det nya steget.
  React.useEffect(() => {
    headingRef.current?.focus();
  }, []);

  return (
    <>
      <h2 className="modal__title" id={titleId} ref={headingRef} tabIndex={-1}>
        {title}
      </h2>
      {children}
    </>
  );
};

export default ModalStep;
